
      import Integral from './integral.vue'
      import type { App, Plugin } from 'vue'

      export const IntegralPlugin: Plugin = {
        install(app: App) {
          app.component('Integral', Integral)
        },
      }
      export { Integral }
      